import { useEffect } from 'react';
import { getConsent } from './CookieConsentBanner';

/**
 * Loads Google Analytics only when the user has consented (localStorage glowapp_analytics_consent === 'granted').
 * Used for GDPR/ePrivacy compliance on the landing page.
 */
const GoogleAnalyticsWhenConsented = () => {
  const gaId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  useEffect(() => {
    if (getConsent() !== 'granted') return;
    if (!gaId || gaId === 'G-XXXXXXXXXX') return;

    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
    document.head.appendChild(script1);

    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', gaId, {
      page_path: window.location.pathname + window.location.search,
      send_page_view: true,
    });

    gtag('event', 'page_view', {
      page_path: window.location.pathname + window.location.search,
      page_title: document.title,
    });

    const trackButtonClick = (event) => {
      const button = event.target.closest('button, a.btn');
      if (button && window.gtag) {
        const buttonText = button.textContent?.trim() || button.getAttribute('aria-label') || 'Button';
        window.gtag('event', 'button_click', {
          button_text: buttonText,
          button_location: button.closest('section')?.id || 'unknown',
        });
      }
    };

    document.addEventListener('click', trackButtonClick);
    return () => document.removeEventListener('click', trackButtonClick);
  }, [gaId]);

  return null;
};

export default GoogleAnalyticsWhenConsented;
